import { PagePayload, EntityList } from '@ot/shared/model';
import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { APITransformer } from '../models';

// TODO: Change this functions to be a service, so it can be properly injected, mocked and tested

/**
 * Update the state with a page entities that include item entities, e.g. fuel receipts, distances
 * The page entities use the pageNumber as id
 * @param state: the state to be updated
 * @param payload: the payload used to update the state
 */
export function updateStateWithPageEntities<T extends { id: string }>(
  state,
  payload: PagePayload<T>
) {
  // get the payload
  const { items, totalSize } = payload;
  // retrieve the pageEntity
  const pageEntity = state.entities[state.pageNumber];
  // retrieve itemEntities(with id as entity id)
  const stateItemEntities: { [id: string]: T } = pageEntity
    ? { ...pageEntity.items }
    : {};
  // merge items
  const itemEntities = items.reduce(
    (reducedEntities: { [id: string]: T }, item: T) => {
      return {
        ...reducedEntities,
        [item.id]: item
      };
    },
    {} //stateItemEntities
  );
  const entities = {
    ...state.entities,
    [state.pageNumber]: {
      ...pageEntity,
      items: itemEntities
    }
  };
  return {
    ...state,
    entities,
    totalSize: totalSize,
    isLoading: false,
    isLoaded: true
  };
}
/**
 * Convert array with id, e.g. [{id:"1"},{id:"2"}] to entities, e.g. {"1":{id:"1"},"2":{id:"2"}}
 * for more efficient query
 * @param itemArray the array to be converted
 * @param initialValue the initial entities for merging with new array items
 * @returns the entities
 */

export function arrayToEntities<T extends { id: string }>(
  itemArray: Array<T>,
  initialValue: EntityList<T>
): EntityList<T> {
  return itemArray.reduce((reducedEntities: EntityList<T>, item: T) => {
    return {
      ...reducedEntities,
      [item.id]: item
    };
  }, initialValue);
}

@Injectable({
  providedIn: 'root'
})
export class EntityMappingService {
  mapResponseToPagePayload<Type, APIType>(
    response: HttpResponse<APIType[]>,
    transformer: APITransformer<Type, APIType>
  ): PagePayload<Type> {
    return {
      items: response.body.map(transformer.fromAPI),
      totalSize: +response.headers.get('x-total-count')
    };
  }
}
